export const WP_PLAYLIST_MDX_DIRECTIVE_NAME = 'wp-playlist';
